<template>
  <b-modal
    v-model="isVisible"
    :title="$t('eula.title')"
    centered
    size="lg"
    ok-only
    :ok-title="$t('eula.closeBtn')"
    @hidden="markTermsAsRead"
  >
    <iframe
      v-if="eulaContent"
      :srcdoc="eulaContent"
      class="eula-iframe"
    />
  </b-modal>
</template>

<script>
import { ref, computed, getCurrentInstance } from '@vue/composition-api'
import useAppConfig from '@core/app-config/useAppConfig'
import eulaHtmlEn from '@/assets/html/eula_agreement.html'
import eulaHtmlCy from '@/assets/html/eula_agreement_cy.html'
import * as AuthService from '@/services/AuthService';

export default {
  name: 'Eula',
  setup() {
    const isVisible = ref(false)
    const baseHtml = ref('')
    const { skin } = useAppConfig()

    // Get the current Vue instance to access $i18n
    const vm = getCurrentInstance().proxy

    const eulaContent = computed(() => {
      if (!baseHtml.value) return ''

      const isDark = skin.value === 'dark' || skin.value === 'semi-dark'
      const rawHtml = baseHtml.value.default || baseHtml.value

      // Inject the dark-mode class if needed
      if (isDark) {
        return rawHtml.replace('<body>', '<body class="dark-mode">')
      }
      return rawHtml.replace('<body class="dark-mode">', '<body>')
    })

    const loadEulaContent = () => {
      const currentLocale = vm.$i18n.locale

      const selectedHtml = currentLocale === 'cy' ? eulaHtmlCy : eulaHtmlEn
      baseHtml.value = selectedHtml.default || selectedHtml
    }

    const showModal = () => {
      loadEulaContent()
      isVisible.value = true
    }

    const markTermsAsRead = () => {
      const userId = AuthService.getUserId()
      if (userId) {
        localStorage.setItem(`${userId}-terms-read`, 'true');
      }
    }

    return {
      isVisible,
      eulaContent,
      showModal,
      markTermsAsRead,
    }
  },
}
</script>

<style scoped>
.eula-iframe {
  width: 100%;
  height: 60vh;
  border: none;
  border: 1px solid #ebe9f1;
  border-radius: 0.357rem;
}

.dark-layout .eula-iframe {
  border-color: #3b4253;
}
</style>
